/** The last-seen 12 / 24-hour preference, for plain functions (formatters, input hints). Set from /me by useClockPref. */
import type { ClockPref } from '@tradeoutlet/shared';

let current: ClockPref = '24h';
export const getClockPref = (): ClockPref => current;
export const setClockPref = (p: ClockPref) => { current = p; };
